import React, { useContext, useEffect } from 'react';

import { PopupContext } from '@app/dev/contexts/popup';
import { popupsList } from '@app/dev/constants/popups';
import { broadcast, broadcastChannels } from '@common/helpers/broadcast';

import './style.scss';
import Config from '@app/dev/config/main';

export const Popup = () => {
  const [{ openPopup, closePopup }, activePopups] = useContext(PopupContext);

  const listenOpenPopup = (e) => {
    openPopup(e.detail.name, e.detail.popupData);
  };

  useEffect(() => {
    broadcast.addEventListener(broadcastChannels.OpenPopup, listenOpenPopup);

    return () => {
      broadcast.removeEventListener(broadcastChannels.OpenPopup, listenOpenPopup);
    };
  }, []);

  if (!activePopups.length) return null;

  return (
    activePopups.map((popup) => {
      const PopupComponent = popupsList[popup.type];

      const popupParams = {
        ...popup.params,
        openPopup,
        closePopup,
      };

      return (
        <div key={popup.type} className="popup-wrapper">
          <div
            className={`popup-wrapper-content popup-position-${popup.params.popupPosition || Config.defaultPopupPosition}`}
            onClick={(e) => e.stopPropagation()}
          >
            <PopupComponent {...popupParams} />
          </div>
        </div>
      )
    })
  );
};
